import script from "./paginationContractHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./paginationContractHistory.vue?vue&type=script&lang=ts&setup=true"

import "./paginationContractHistory.vue?vue&type=style&index=0&id=70df9879&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70df9879"]])

export default __exports__